import { useCallback } from 'react'
import { useAuth } from '@/lib/auth/AuthProvider'
import { fmtMoney } from '../shared/format'
import { PROJECT_PRICE_READ_PERM } from './permissions'

/** Fiyat yetkisi olmayan kullanıcıya API fiyatı göndermez; ekranda sıfır yerine gizli gösterilir. */
export function usePriceFormat() {
  const { can } = useAuth()
  const visible = can(PROJECT_PRICE_READ_PERM)
  return useCallback((amount: string) => (visible ? fmtMoney(amount) : '••••'), [visible])
}
